<template>
    <div class="ranking-slot">
      <div class="rank-num">{{ rankNum }}</div>
      <div class="class-type">
        <q-img
          v-if="getClassToImageName(chaInfo.ChaClass ? chaInfo.ChaClass : chaInfo.cha_info.ChaClass) === 'm_brawl'"
          src="../../assets/class/m_braw.jpg" 
        />
        <q-img
          v-else-if="getClassToImageName(chaInfo.ChaClass ? chaInfo.ChaClass : chaInfo.cha_info.ChaClass) === 'f_brawler'"
          src="../../assets/class/f_brawler.jpg" 
        />
        <q-img
          v-else-if="getClassToImageName(chaInfo.ChaClass ? chaInfo.ChaClass : chaInfo.cha_info.ChaClass) === 'm_sword'"
          src="../../assets/class/m_sword.jpg" 
        />
        <q-img
          v-else-if="getClassToImageName(chaInfo.ChaClass ? chaInfo.ChaClass : chaInfo.cha_info.ChaClass) === 'f_swords'"
          src="../../assets/class/f_swords.jpg" 
        />
        <q-img
          v-else-if="getClassToImageName(chaInfo.ChaClass ? chaInfo.ChaClass : chaInfo.cha_info.ChaClass) === 'f_archer'"
          src="../../assets/class/f_archer.jpg" 
        />
        <q-img
          v-else-if="getClassToImageName(chaInfo.ChaClass ? chaInfo.ChaClass : chaInfo.cha_info.ChaClass) === 'm_archer'"
          src="../../assets/class/m_archer.png" 
        />
        <q-img
          v-else-if="getClassToImageName(chaInfo.ChaClass ? chaInfo.ChaClass : chaInfo.cha_info.ChaClass) === 'f_shaman'"
          src="../../assets/class/f_shaman.jpg" 
        />
        <q-img
          v-else-if="getClassToImageName(chaInfo.ChaClass ? chaInfo.ChaClass : chaInfo.cha_info.ChaClass) === 'm_shaman'"
          src="../../assets/class/m_shaman.jpg" 
        />
        <q-img
          v-else-if="getClassToImageName(chaInfo.ChaClass ? chaInfo.ChaClass : chaInfo.cha_info.ChaClass) === 'm_extreme'"
          src="../../assets/class/m_extreme.png" 
        />
        <q-img
          v-else-if="getClassToImageName(chaInfo.ChaClass ? chaInfo.ChaClass : chaInfo.cha_info.ChaClass) === 'f_extreme'"
          src="../../assets/class/f_extreme.png" 
        />
        <q-img
          v-else-if="getClassToImageName(chaInfo.ChaClass ? chaInfo.ChaClass : chaInfo.cha_info.ChaClass) === 'm_assassin'"
          src="../../assets/class/m_assassin.png" 
        />
        <q-img
          v-else-if="getClassToImageName(chaInfo.ChaClass ? chaInfo.ChaClass : chaInfo.cha_info.ChaClass) === 'f_assassin'"
          src="../../assets/class/f_assassin.png" 
        />
        <q-img
          v-else-if="getClassToImageName(chaInfo.ChaClass ? chaInfo.ChaClass : chaInfo.cha_info.ChaClass) === 'm_gunner'"
          src="../../assets/class/m_gunner.png" 
        />
        <q-img
          v-else-if="getClassToImageName(chaInfo.ChaClass ? chaInfo.ChaClass : chaInfo.cha_info.ChaClass) === 'f_gunner'"
          src="../../assets/class/f_gunner.png" 
        />
      </div>
      <div class="details">
        <div class="first-row">
          <img v-if="Number(chaInfo.ChaSchool ? chaInfo.ChaSchool : chaInfo.cha_info.ChaSchool) === 0" src="../../assets/school/sg.png">
          <img v-else-if="Number(chaInfo.ChaSchool ? chaInfo.ChaSchool : chaInfo.cha_info.ChaSchool) === 1" src="../../assets/school/mp.png">
          <img v-else-if="Number(chaInfo.ChaSchool ? chaInfo.ChaSchool : chaInfo.cha_info.ChaSchool) === 2" src="../../assets/school/phnx.png">
          <span>{{ chaInfo.ChaName ? chaInfo.ChaName : chaInfo.cha_info.ChaName }}</span>
        </div>
        <div class="others">
          <span>Level: <strong class="level"> {{ chaInfo.ChaLevel ? chaInfo.ChaLevel : chaInfo.cha_info.ChaLevel }}</strong></span>
          <span v-if="type === 'Shaman(Resu)'">Resu: <strong class="kill"> {{ chaInfo.PVPResu }}</strong></span>
          <span v-else-if="chaInfo.PVPKills && type !== 'Shaman(Resu)'">PK Kill: <strong class="kill"> {{ chaInfo.PVPKills }}</strong></span>
          <span v-if="chaInfo.PVPDeaths && type !== 'Shaman(Resu)'">PK Death: <strong class="death"> {{ chaInfo.PVPDeaths }}</strong></span>
          <span v-if="chaInfo.ChaMoney">Gold: <strong class="gold"> {{ Number(chaInfo.ChaMoney).toLocaleString("en-US") }}</strong></span>
          <span v-if="chaInfo.cha_info ? chaInfo.cha_info.Contri : false">Contri: <strong class="gold"> {{ Number(chaInfo.cha_info.Contri).toLocaleString("en-US") }}</strong></span>
          <span v-if="chaInfo.cha_info ? chaInfo.cha_info.ChaExp : false">Exp: <strong class="gold"> {{ Number(chaInfo.cha_info.ChaExp).toLocaleString("en-US") }}</strong></span>
        </div>
      </div>
    </div>
  </template>
  <script>
  export default {
    name: 'RankingSlot',
    props: {
      chaInfo: {
        require: true,
        type: Object
      },
      rankNum: {
        required: true,
        type: Number
      },
      type: {
        required: false,
        type: String,
        default: ''
      }
    }
  }
  </script>
  
  <style lang="scss">
  .ranking-slot {
    display: grid;
    grid-template-columns: .1fr .5fr 1fr;
    gap: 24px;
    margin-top: 16px;

    .rank-num {
      color: white;
      margin-left: 50px;
      margin-top: 15px;
    }

    .class-type {
      margin-left: auto;
      .q-img {
        width: 50px;
        height: 50px;
      }
    }
    .details {
      .first-row {
        display: grid;
        grid-template-columns: .1fr 1fr;
        gap: 2px;
        
        .img {
          width: 16px;
          height: 11px;
        }

        span {
          font-size: 13px;
          font-weight: 500;
          line-height: normal;
          white-space: nowrap;
          color: white;
        }
      }  
      .others {
        margin-top: 8px;
        display: grid;
        grid-template-rows: 1fr 1fr;
        gap: 1px;
        color: white;
        span {
          font-size: 13px;
        }

        .kill {
          color: green;
          font-size: 13px;
        }
        .death {
          color: red;
          font-size: 13px;
        }
        .gold {
          color: yellow;
          font-size: 13px;
        }
      }
    }
  }
  </style>